import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import RegionJson from "@/assets/json/region.json";
import Pagination from "laravel-vue-pagination";
import axios from "axios";
import { mapGetters } from "vuex";
import store from "@/store";
import { ConvertNumService } from "@/assets/js/convertNumberService.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
const convertNumberService = new ConvertNumService();

export default {
    name: "homeIndexSearchResult",
    components: {
        MainLayout,
        Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            jobList: {},
            isLoading: true,
            category: [],
            isCategoryDropdownOpen: false,
            isJobTypeDropdownOpen: false,
            isRegionDropdownOpen: false,
            regionArr: RegionJson,
            page_status: false,
            keyword: {
                job_title: "",
                job_type: "",
                category_name: "",
                region: ""
            },
            job_count: "",
            resumeCount: "",
            oldKeyword: this.$route.params.oldKeyword
        };
    },

    computed: {
        ...mapGetters({ isApplicantLoggedIn: "isApplicantLoggedIn", applicantId: "applicantId", applicantToken: "applicantToken" , resumeCountNo: "resumeCountNo"}),

        selectedCategoryName() {
            const selected = this.category.find(cat => cat.id === this.keyword.category_name);
            return selected ? selected.category_name : '';
        },

        selectedJobTypeName() {
            const types = {
                '1': 'Full-time',
                '2': 'Part-time',
                '3': 'Internship',
                '4': 'Freelance',
                '5': 'Remote Job',
            };
            return types[this.keyword.job_type] || '';
        },

        selectedRegionName() {
            if (this.keyword.region === '' || this.keyword.region === null || this.keyword.region === undefined) {
                return '';
            }
            return this.regionArr[this.keyword.region] || '';
        }
    },

    methods: {
        getAllJobs(page = 1) {
            axios.get("/applicant/job/list?page=" + page)
                .then(response => {
                    this.jobList = response.data || {};
                    this.job_count = this.jobList.total ? convertNumberService.convertEng2Mm(this.jobList.total.toString()) : convertNumberService.convertEng2Mm("0");
                })
                .catch(error => {
                    console.log("Get Jobs API Error", error);
                });
        },

        getCategory() {
            axios.get("/job/category/list?has_jobs=true")
                .then(response => {
                    this.category = response.data;
                })
                .catch(error => {
                    console.log("Get Category API Error", error);
                })
        },

        getResumeCount() {
            axios.get("/applicant/resume/count/" + this.applicantId)
                .then(response => {
                    this.resumeCount = response.data.count;
                    store.commit("setResumeCount", this.resumeCount);
                })
                .catch(error => {
                    console.log("Resume Count API error:::::>", error.response.data);
                });
        },

        goResumeRegister() {
            if (!this.isApplicantLoggedIn) {
                this.$router.push({ name: 'applicantLogin' });
                return;
            }
            if (this.resumeCountNo < 3) {
                this.$router.push('/resume', () => {});
            } else {
                this.$notification.error("အလုပ်လျှောက်လွှာအများဆုံး ၃ ခုသာ ပြုလုပ်ခွင့်ပြုသည်။", { timer: 3 , position: 'bottomCenter'});
            }
        },

        searchJob(page = 1) {
            const hasRegion = this.keyword.region !== '' && this.keyword.region !== null && this.keyword.region !== undefined;
            var request = {
                params: {
                    keyword: this.keyword.job_title,
                    keyword1: this.keyword.category_name,
                    keyword2: hasRegion ? this.keyword.region : '',
                    keyword3: this.keyword.job_type
                }
            };
            this.isLoading = true;
            axios.get("/applicant/search/jobresult?page=" + page, request)
                .then(response => {
                    this.page_status = true;
                    this.jobList = response.data || {};
                    this.job_count = this.jobList.total ? convertNumberService.convertEng2Mm(this.jobList.total.toString()) : convertNumberService.convertEng2Mm("0");
                    this.$route.params.oldKeyword = "";
                })
                .catch(error => {
                    console.log("Job Search API Error", error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getJobType(job_type) {
            if (job_type == '1') {
              this.job_type = 'Full-time';
            } else if (job_type == '2') {
              this.job_type = 'Part-time';
            } else if (job_type == '3') {
              this.job_type = 'Internship';
            } else if (job_type == '4') {
              this.job_type = 'Freelance';
            } else if (job_type == '5') {
                this.job_type = 'Remote Job';
            } else {
              this.job_type = 'သတ်မှတ်ထားခြင်းမရှိပါ';
            }
            return this.job_type;
          },

        goFB(id) {
            window.open("https://www.facebook.com/sharer/sharer.php?u=http://bib-job.com/job_listing/job_detail/"+id+"&t="+document.title, '',
            'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=500');
        },

        toggleCategoryDropdown() {
            this.isCategoryDropdownOpen = !this.isCategoryDropdownOpen;
            this.isJobTypeDropdownOpen = false;
            this.isRegionDropdownOpen = false;
        },

        selectCategory(id) {
            this.keyword.category_name = id;
            this.isCategoryDropdownOpen = false;
        },

        toggleJobTypeDropdown() {
            this.isJobTypeDropdownOpen = !this.isJobTypeDropdownOpen;
            this.isCategoryDropdownOpen = false;
            this.isRegionDropdownOpen = false;
        },

        selectJobType(id) {
            this.keyword.job_type = id;
            this.isJobTypeDropdownOpen = false;
        },

        toggleRegionDropdown() {
            this.isRegionDropdownOpen = !this.isRegionDropdownOpen;
            this.isCategoryDropdownOpen = false;
            this.isJobTypeDropdownOpen = false;
        },

        selectRegion(id) {
            this.keyword.region = id;
            this.isRegionDropdownOpen = false;
        },

        handleOutsideClick(e) {
            if (!e.target.closest('.custom-select-wrapper')) {
                this.isCategoryDropdownOpen = false;
                this.isJobTypeDropdownOpen = false;
                this.isRegionDropdownOpen = false;
            }
        },
    },

    mounted() {
        this.getCategory();
        if (this.oldKeyword) {
            this.keyword.job_title = this.oldKeyword.keyword || '';
            this.keyword.category_name = this.oldKeyword.keyword1 || '';
            this.keyword.region = this.oldKeyword.keyword2 !== undefined && this.oldKeyword.keyword2 !== null ? this.oldKeyword.keyword2 : '';
            this.keyword.job_type = this.oldKeyword.keyword3 || '';
        }
        this.searchJob();
        if (this.applicantId) {   
            this.getResumeCount();
        }
        window.addEventListener('click', this.handleOutsideClick);
    },

    beforeDestroy() {
        window.removeEventListener('click', this.handleOutsideClick);
    }
};
